import { render } from "./App.vue?vue&type=template&id=d291e9e0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d291e9e0&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__